import { gql } from "@apollo/client";

const schema = {
  request: {
    name: "activateLabRequest",
    serviceName: "auth",
    query: gql`
      mutation activateLabRequest($lab_id: String!) {
        activateLabRequest(lab_id: $lab_id) {
          messages
        }
      }
    `,
  },
};

export default schema;
